var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.getCssClass(),
      style: _vm.input.style,
      attrs: { type: _vm.input.type, id: _vm.input.id },
    },
    [
      _c(
        "label",
        [
          _c(
            "span",
            [
              _vm._v("\n              " + _vm._s(_vm.input.label) + " "),
              _vm.input.required
                ? _c("small", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _vm._v(" \n              "),
              _vm.input.helper
                ? _c("HelperBox", { attrs: { text: _vm.input.helper } })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.input.type == "site-name-readonly"
            ? [
                _c("input", {
                  attrs: { type: "hidden" },
                  domProps: {
                    value: _vm.getNestedValue(_vm.formValue, _vm.input.value),
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "10px",
                      border: "1px solid rgba(92,91,100,0.15)",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.getSiteName(_vm.formValue.siteReference.id))
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.input.type == "text" ||
          _vm.input.type == "email" ||
          _vm.input.type == "password"
            ? [
                _c("input", {
                  attrs: {
                    type: _vm.input.type,
                    placeholder: _vm.input.placeholder,
                    disabled: _vm.isDisabled(),
                  },
                  domProps: {
                    value: _vm.getNestedValue(_vm.formValue, _vm.input.value),
                  },
                  on: {
                    keyup: function ($event) {
                      return _vm.onValueChange(
                        $event,
                        _vm.input.value,
                        _vm.input.callback
                      )
                    },
                    blur: function ($event) {
                      return _vm.autoSave()
                    },
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.input.type == "number"
            ? [
                _c("input", {
                  attrs: {
                    type: "text",
                    placeholder: _vm.input.placeholder,
                    disabled: _vm.isDisabled(),
                  },
                  domProps: {
                    value: _vm.getNestedValue(_vm.formValue, _vm.input.value),
                  },
                  on: {
                    keyup: function ($event) {
                      return _vm.onNumberKeyUp($event, _vm.input)
                    },
                    keydown: function ($event) {
                      return _vm.onNumberKeyDown($event, _vm.input)
                    },
                    blur: function ($event) {
                      return _vm.autoSave()
                    },
                  },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.input.type == "textarea"
            ? [
                _c(
                  "textarea",
                  {
                    attrs: {
                      type: _vm.input.type,
                      placeholder: _vm.input.placeholder,
                      disabled: _vm.isDisabled(),
                    },
                    on: {
                      keyup: function ($event) {
                        return _vm.onValueChange(
                          $event,
                          _vm.input.value,
                          _vm.input.callback
                        )
                      },
                      blur: function ($event) {
                        return _vm.autoSave()
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.getNestedValue(_vm.formValue, _vm.input.value))
                    ),
                  ]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.input.type == "calendar"
            ? [
                _vm.isDisabled()
                  ? [
                      _c("input", {
                        attrs: { type: "text", disabled: "disabled" },
                        domProps: {
                          value: _vm.formatIsoDateToShortDate(
                            _vm.getNestedValue(_vm.formValue, _vm.input.value)
                          ),
                        },
                      }),
                    ]
                  : [
                      _c("date-picker", {
                        attrs: {
                          type: "date",
                          "default-value": _vm.getNestedValue(
                            _vm.formValue,
                            _vm.input.value
                          ),
                          format: "DD-MMM-YYYY",
                          placeholder: "DD-MMM-YYYY",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.setDateValue(
                              $event,
                              _vm.input.value,
                              _vm.input.callback
                            )
                          },
                        },
                        model: {
                          value: _vm.datePickerModel,
                          callback: function ($$v) {
                            _vm.datePickerModel = $$v
                          },
                          expression: "datePickerModel",
                        },
                      }),
                    ],
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.input.type === "treatmentgroup-for-actuals"
            ? [
                _vm.getDispensingUnits(_vm.formValue).length === 0
                  ? [
                      _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
                        _vm._v(
                          "\n          You need to have defined dispensingunits before you can select treatment group for actuals.\n        "
                        ),
                      ]),
                    ]
                  : _vm.getTreatmentGroupsActuals().length === 0
                  ? [
                      _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
                        _vm._v(
                          "\n          You need to have defined treatmentgroups before you can choose any actuals.\n        "
                        ),
                      ]),
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "inner grid-50w" },
                        _vm._l(_vm.getTreatmentGroupsActuals(), function (tg) {
                          return _c("div", { staticClass: "input" }, [
                            _c("label", [
                              _vm._v(
                                "\n                    Actual for: " +
                                  _vm._s(tg.name) +
                                  "\n                  "
                              ),
                              _c("input", {
                                attrs: { type: "hidden" },
                                domProps: { value: tg.id },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "text",
                                  pattern: "[0-9]+([\\.][0-9]{1,2})?",
                                  placeholder: "Actual enrolment",
                                  disabled: _vm.isDisabled(),
                                },
                                domProps: { value: tg.enrolled },
                              }),
                            ]),
                          ])
                        }),
                        0
                      ),
                    ],
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.input.type === "planned-batch-stock-adjustments"
            ? [
                _vm.getPlannedBatchs().length === 0
                  ? [
                      _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
                        _vm._v(
                          "\n            You need to have planned batches before making stock adjustments.\n          "
                        ),
                      ]),
                    ]
                  : _vm.getPlannedBatchesForStockAdjustment(_vm.formValue)
                      .length === 0
                  ? [
                      _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
                        _vm._v(
                          "\n          There are no planned batches that fullfill criteria. \n        "
                        ),
                      ]),
                    ]
                  : _vm.getSupplyChains().length === 0
                  ? [
                      _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
                        _vm._v(
                          "\n          You need to have defined a supply chaing before making stock adjustments.\n          "
                        ),
                      ]),
                    ]
                  : _vm.getDispensingUnits(_vm.formValue).length === 0
                  ? [
                      _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
                        _vm._v(
                          "\n          You need to have defined dispensingunits before making stock adjustments.\n          "
                        ),
                      ]),
                    ]
                  : [
                      _c(
                        "select",
                        {
                          attrs: { disabled: _vm.isDisabled() },
                          on: {
                            change: function ($event) {
                              return _vm.onValueChange(
                                $event,
                                _vm.input.value,
                                _vm.input.callback
                              )
                            },
                            blur: function ($event) {
                              return _vm.autoSave()
                            },
                          },
                        },
                        [
                          _c("option", [
                            _vm._v("Please select a production/planned-batch"),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            this.getPlannedBatchesForStockAdjustment(
                              _vm.formValue
                            ),
                            function (plannedBatch) {
                              return _c(
                                "option",
                                {
                                  domProps: {
                                    value: plannedBatch.batchGuid,
                                    selected:
                                      _vm.getNestedValue(
                                        _vm.formValue,
                                        _vm.input.value
                                      ) === plannedBatch.batchGuid
                                        ? "selected"
                                        : "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(plannedBatch.name) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
              ]
            : _vm.input.type == "select"
            ? [
                _c(
                  "select",
                  {
                    attrs: { disabled: _vm.isDisabled() },
                    on: {
                      change: function ($event) {
                        return _vm.onValueChange(
                          $event,
                          _vm.input.value,
                          _vm.input.callback
                        )
                      },
                      blur: function ($event) {
                        return _vm.autoSave()
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "" } }, [
                      _vm._v("Select item"),
                    ]),
                    _vm._v(" "),
                    _vm.input.preValues == "supplyStrategies"
                      ? _vm._l(
                          this.$store.getters.supplyStrategies,
                          function (pre) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: pre.value,
                                  selected:
                                    _vm.getNestedValue(
                                      _vm.formValue,
                                      _vm.input.value
                                    ) == pre.value
                                      ? "selected"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(pre.name) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.input.preValues == "primaryPackages"
                      ? _vm._l(
                          this.getPrimaryPackages(_vm.formValue),
                          function (pre) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: pre.id,
                                  selected:
                                    _vm.getNestedValue(
                                      _vm.formValue,
                                      _vm.input.value
                                    ) == pre.id
                                      ? "selected"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(pre.name) +
                                    "\n            "
                                ),
                              ]
                            )
                          }
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.input.preValues == "secondaryPackages"
                      ? _vm._l(
                          this.getSecondaryPackages(_vm.formValue),
                          function (pre) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: pre.id,
                                  selected:
                                    _vm.getNestedValue(
                                      _vm.formValue,
                                      _vm.input.value
                                    ) == pre.id
                                      ? "selected"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(pre.name) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.input.preValues == "dispensingUnits"
                      ? _vm._l(
                          this.getDispensingUnits(_vm.formValue),
                          function (pre) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: pre.id,
                                  selected:
                                    _vm.getNestedValue(
                                      _vm.formValue,
                                      _vm.input.value
                                    ) == pre.id
                                      ? "selected"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(pre.name) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.input.preValues == "studyDosageForms"
                      ? _vm._l(
                          this.$store.getters.studyDosageForms,
                          function (pre) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: pre,
                                  selected:
                                    _vm.getNestedValue(
                                      _vm.formValue,
                                      _vm.input.value
                                    ) == pre
                                      ? "selected"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(pre) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        )
                      : _vm.input.preValues == "studyPackaging"
                      ? _vm._l(
                          this.$store.getters.studyPackaging,
                          function (pre) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: pre,
                                  selected:
                                    _vm.getNestedValue(
                                      _vm.formValue,
                                      _vm.input.value
                                    ) == pre
                                      ? "selected"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(pre) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        )
                      : _vm.input.preValues == "studyUnits"
                      ? _vm._l(this.$store.getters.studyUnits, function (pre) {
                          return _c(
                            "option",
                            {
                              domProps: {
                                value: pre,
                                selected:
                                  _vm.getNestedValue(
                                    _vm.formValue,
                                    _vm.input.value
                                  ) == pre
                                    ? "selected"
                                    : "",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(pre) + "\n          "
                              ),
                            ]
                          )
                        })
                      : _vm.input.preValues == "currency"
                      ? _vm._l(
                          this.$store.getters.currencyList,
                          function (pre) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: pre.code,
                                  selected:
                                    _vm.getNestedValue(
                                      _vm.formValue,
                                      _vm.input.value
                                    ) == pre.code
                                      ? "selected"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(pre.code) +
                                    " - " +
                                    _vm._s(pre.symbol) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        )
                      : _vm.input.preValues == "countries"
                      ? _vm._l(this.$store.getters.countryList, function (pre) {
                          return _c(
                            "option",
                            {
                              domProps: {
                                value: pre.code,
                                selected:
                                  _vm.getNestedValue(
                                    _vm.formValue,
                                    _vm.input.value
                                  ) == pre.code
                                    ? "selected"
                                    : "",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(pre.name) +
                                  "\n          "
                              ),
                            ]
                          )
                        })
                      : Array.isArray(_vm.input.preValues)
                      ? _vm._l(_vm.input.preValues, function (pre) {
                          return _c(
                            "option",
                            {
                              domProps: {
                                value: pre.value,
                                selected:
                                  _vm.getNestedValue(
                                    _vm.formValue,
                                    _vm.input.value
                                  ) == pre.value
                                    ? "selected"
                                    : "",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(pre.name) +
                                  "\n          "
                              ),
                            ]
                          )
                        })
                      : typeof _vm.input.preValues == "object"
                      ? [
                          _vm.input.preValues.field == "supplyChainDepots"
                            ? _vm._l(
                                this.getSelectSupplyChainDepots(
                                  _vm.input.preValues
                                ),
                                function (pre) {
                                  return _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: pre.supplyChainId,
                                        selected:
                                          _vm.getNestedValue(
                                            _vm.formValue,
                                            _vm.input.value
                                          ) == pre.supplyChainId
                                            ? "selected"
                                            : "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            pre[_vm.input.preValues.name]
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }
                              )
                            : _vm._l(
                                _vm.getGlobalValues(
                                  _vm.input.preValues.field,
                                  _vm.input.filter,
                                  _vm.input.value
                                ),
                                function (pre) {
                                  return _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: pre[_vm.input.preValues.value],
                                        selected:
                                          _vm.getNestedValue(
                                            _vm.formValue,
                                            _vm.input.value
                                          ) == pre[_vm.input.preValues.value]
                                            ? "selected"
                                            : "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            pre[_vm.input.preValues.name]
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                }
                              ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            : _vm.input.type == "datalist"
            ? [
                _c("input", {
                  attrs: {
                    type: "text",
                    list: _vm.getDatalistName(_vm.input.value),
                    placeholder: _vm.input.placeholder,
                    disabled: _vm.isDisabled(),
                  },
                  domProps: {
                    value: _vm.getNestedValue(_vm.formValue, _vm.input.value),
                  },
                  on: {
                    keyup: function ($event) {
                      return _vm.onValueChange(
                        $event,
                        _vm.input.value,
                        _vm.input.callback
                      )
                    },
                    blur: function ($event) {
                      return _vm.autoSave()
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "datalist",
                  { attrs: { id: _vm.getDatalistName(_vm.input.value) } },
                  [
                    _vm.input.preValues == "studyPackaging"
                      ? _vm._l(
                          this.$store.getters.studyPackaging,
                          function (pre) {
                            return _c(
                              "option",
                              {
                                domProps: {
                                  value: pre,
                                  selected:
                                    _vm.getNestedValue(
                                      _vm.formValue,
                                      _vm.input.value
                                    ) == pre
                                      ? "selected"
                                      : "",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(pre) +
                                    "\n          "
                                ),
                              ]
                            )
                          }
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            : _vm.input.type == "radiolist"
            ? [
                _c(
                  "section",
                  [
                    _vm._l(_vm.input.preValues, function (pre) {
                      return [
                        _c("label", { staticClass: "radio" }, [
                          _c("input", {
                            attrs: {
                              type: "radio",
                              name: _vm.input.value + _vm.formValue.id,
                              disabled: _vm.isDisabled(),
                            },
                            domProps: {
                              checked:
                                _vm.getNestedValue(
                                  _vm.formValue,
                                  _vm.input.value
                                ) == pre.value,
                              value: pre.value,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onValueChange(
                                  $event,
                                  _vm.input.value,
                                  _vm.input.callback
                                )
                              },
                              blur: function ($event) {
                                return _vm.autoSave()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v(
                              _vm._s(pre.name == undefined ? pre : pre.name)
                            ),
                          ]),
                        ]),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            : _vm.input.type == "checkboxlist"
            ? [
                _c(
                  "section",
                  [
                    _vm._l(_vm.input.preValues, function (pre) {
                      return [
                        _c("label", { staticClass: "radio" }, [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              disabled: _vm.isDisabled(),
                            },
                            domProps: {
                              checked: _vm.getNestedValue(
                                _vm.formValue,
                                _vm.input.value + "." + pre.value
                              ),
                              value: _vm.getNestedValue(
                                _vm.formValue,
                                _vm.input.value + "." + pre.value
                              ),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onValueChange(
                                  $event,
                                  _vm.input.value + "." + pre.value,
                                  _vm.input.callback
                                )
                              },
                              blur: function ($event) {
                                return _vm.autoSave()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("small", [_vm._v(_vm._s(pre.label))]),
                        ]),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            : _vm.input.type == "checkbox" || _vm.input.type == "radio"
            ? [
                _c("section", [
                  _c("label", { staticClass: "radio" }, [
                    _c("input", {
                      attrs: {
                        type: _vm.input.type,
                        disabled: _vm.isDisabled(),
                      },
                      domProps: {
                        checked: _vm.getNestedValue(
                          _vm.formValue,
                          _vm.input.value
                        ),
                        value: _vm.getNestedValue(
                          _vm.formValue,
                          _vm.input.value
                        ),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.onValueChange(
                            $event,
                            _vm.input.value,
                            _vm.input.callback
                          )
                        },
                        blur: function ($event) {
                          return _vm.autoSave()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("small", [_vm._v(_vm._s(_vm.input.label))]),
                  ]),
                  _vm._v(" "),
                  _vm.input.description != ""
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "line-height": "1.5",
                            "margin-left": "17px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.input.description))]
                      )
                    : _vm._e(),
                ]),
              ]
            : _vm.input.type == "void"
            ? [_c("section", { staticClass: "void" }, [_vm._v(" ")])]
            : _vm.input.type == "button"
            ? [
                _c(
                  "button",
                  {
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.onButtonClick($event, _vm.input.callback)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.input.buttonText))]
                ),
              ]
            : _vm.input.type == "buttonlist"
            ? [
                _c(
                  "section",
                  _vm._l(_vm.input.preValues, function (pre) {
                    return _c(
                      "button",
                      {
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.onButtonListClick(
                              pre.globalValue,
                              pre.callback
                            )
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(pre.label) + "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            : _vm.input.type == "fileupload"
            ? [
                _c(
                  "label",
                  {
                    staticClass: "button",
                    attrs: { for: this.toCustomFormName(_vm.input.buttonText) },
                  },
                  [
                    _c("input", {
                      attrs: {
                        id: this.toCustomFormName(_vm.input.buttonText),
                        name: this.toCustomFormName(_vm.input.buttonText),
                        type: "file",
                        accept: ".xlsx,.xls",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.onFileUploadChange($event, _vm.input)
                        },
                      },
                    }),
                    _vm._v(
                      "\n        " + _vm._s(_vm.input.buttonText) + "\n      "
                    ),
                  ]
                ),
              ]
            : _vm.input.type == "typeahead-countries"
            ? [
                _c("treeselect", {
                  attrs: {
                    multiple: _vm.input.multiple,
                    options: this.getCountryOptions(_vm.formValue),
                    placeholder: _vm.input.placeholder,
                    "disable-branch-nodes": false,
                    clearable: true,
                    disableFuzzyMatching: true,
                    "append-to-body": true,
                    instanceId: _vm.input.value,
                    value: _vm.getNestedValueNullIfEmpty(
                      _vm.formValue,
                      _vm.input.value
                    ),
                    "value-consists-of": "LEAF_PRIORITY",
                  },
                  on: {
                    input: _vm.onTypeAheadChange,
                    close: function ($event) {
                      return _vm.onTypeAheadCallback(
                        _vm.input.callback,
                        _vm.input.preValues.field
                      )
                    },
                  },
                }),
              ]
            : _vm.input.type == "typeahead"
            ? [
                _c("treeselect", {
                  attrs: {
                    multiple: _vm.input.multiple,
                    options: _vm.getTypeAheadData(
                      _vm.input.preValues,
                      _vm.input.appendAll,
                      _vm.input.filter,
                      _vm.input.value
                    ),
                    value: _vm.getNestedValue(_vm.formValue, _vm.input.value),
                    instanceId: _vm.input.value,
                    "disable-branch-nodes": false,
                    clearable: false,
                    disableFuzzyMatching: true,
                    "value-consists-of": "LEAF_PRIORITY",
                    "append-to-body": true,
                    placeholder: _vm.input.placeholder,
                  },
                  on: {
                    input: _vm.onTypeAheadChange,
                    close: function ($event) {
                      return _vm.onTypeAheadCallback(
                        _vm.input.callback,
                        _vm.input.preValues.field
                      )
                    },
                  },
                }),
              ]
            : _vm.input.type == "guid"
            ? [
                _c("input", {
                  attrs: { type: "hidden" },
                  domProps: {
                    value: _vm.getSetGuid(_vm.formValue, _vm.input.value),
                  },
                }),
              ]
            : _vm.input.type == "hidden"
            ? [
                _c("input", {
                  attrs: { type: "hidden" },
                  domProps: {
                    value: _vm.setFormNestedValue(
                      _vm.input.preValue,
                      _vm.input.value
                    ),
                  },
                }),
              ]
            : _vm.input.type == "label"
            ? [
                _c("section", [
                  _vm._v(
                    _vm._s(_vm.getNestedValue(_vm.formValue, _vm.input.value)) +
                      "  "
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.input.inline
            ? [
                _c("small", [
                  _vm._v(_vm._s(_vm.getInlineText(_vm.input.inline))),
                ]),
              ]
            : _vm.input.inlineSelect
            ? [
                _c("small", [
                  _c(
                    "select",
                    {
                      attrs: { disabled: _vm.isDisabled() },
                      on: {
                        change: function ($event) {
                          return _vm.onValueChange(
                            $event,
                            _vm.input.value + "Select",
                            _vm.input.callback
                          )
                        },
                        blur: function ($event) {
                          return _vm.autoSave()
                        },
                      },
                    },
                    _vm._l(_vm.input.inlineSelect, function (option) {
                      return _c(
                        "option",
                        {
                          domProps: {
                            selected:
                              _vm.getNestedValue(
                                _vm.formValue,
                                _vm.input.value + "Select"
                              ) == option.value
                                ? "selected"
                                : "",
                            value: option.value,
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(option.name) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }